import type { Directive } from 'vue'

export const clickOutsideFilterDirective: Directive<
  any,
  (event: Event) => void
> = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event: Event) {
      // here I check that click was outside the el and his childrens
      if (
        !(el == event.target || el.contains(event.target)) &&
        !(event.target as HTMLElement).classList.contains('filter-btn')
      ) {
        // and if it did, call method provided in attribute value
        binding.value(event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
}
